<template>
    <div class="row">
        <div class="col" v-if="data">
            <div class="row">
                <div class="col-lg-6">
                    <h3>{{ data.label }}</h3>
                </div>
                <div class="col-lg-6">
                    <p class="text-lg-right sau-font sm pt-2">Last Updated: {{ new Date() | moment('DD/MM/YYYY H:mm:ss') }}</p>
                </div>
            </div>
            <div class="sau-bx bx-pad">
                <canvas :id="graphId" class="horizontal-single-bar-graph" style="height:100px; width:100%;" :data-points="JSON.stringify(data)"></canvas>
                <p class="sau-font sm pt-2 text-center">Limit - {{ data.limit }}, Used - {{ data.usage }}</p>
            </div>
        </div>
        <div class="col" v-else>
            <div class="sau-bx bx-pad text-center">
                <h4>No {{ data.label }} graphs available</h4>
                <p>We can't retrieve your bandwidth data at the moment. However support can quickly attend to this.</p>
                <a href="#" class="sau-link-button sm" @click.prevent="actionSupport">Contact support</a>
            </div>
        </div>
    </div>
</template>

<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    props:['data'],
    data() {
        return {
            graphId:'',
        }
    },
    created() {
        this.graphId = this.data.label.replace(' ','') + Math.floor((Math.random() * 10) + 1);
        this.$nextTick(() => {
            this.checkGraphs();
        });
    },
}
</script>
<style>
</style>
